var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserknownok16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-144)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: -8.8818e-16,
    width: 16,
    height: 16,
    fill: "none",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 0c-2.2091 2.7614e-7 -4 1.7909-4 4 2e-5 1.3614 0.69249 2.6294 1.8379 3.3652-2.8336 0.98833-4.8379 3.8619-4.8379 7.1348 8e-5 0.82839 0.67161 1.4999 1.5 1.5h8.0859l-1.5859-1.5859v-2.4141h2.4141l0.76172 0.76172 1.543-2.5703c-0.85891-1.3062-2.0972-2.3172-3.5566-2.8262 1.1454-0.73588 1.8379-2.0038 1.8379-3.3652 0-2.2091-1.7909-4-4-4z",
    color: "#000000",
    fill: "#3771c8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159 10-2.625 4.375-1.375-1.375h-1v1l2 2h1l3-5v-1z",
    color: "#000000",
    fill: "#008000",
    strokeLinecap: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserknownok16);
export default __webpack_public_path__ + "static/media/user.known.ok.16.1fe83d362a1f83317bec5da23382c592.svg";
export { ForwardRef as ReactComponent };